import { z } from 'zod';
import { DEFAULTS } from './defaults';

const poolSchema = z
  .object({
    id: z.string().uuid().optional(),
    name: z.string().optional(),
    tags: z.array(z.string()).optional(),
    minPriority: z.number().int().optional(),
    executor: z.string(),
  })
  .refine((pool) => pool.id !== undefined || pool.name !== undefined, {
    message: 'Each pool must specify at least one of "id" or "name"',
  });

const executorSchema = z
  .object({
    type: z.enum(['claude-code', 'http-api', 'anthropic-api', 'webhook', 'custom-script']),
  })
  .passthrough();

const shuttleConfigSchema = z.object({
  auth: z.object({
    /** Optional. Pairing-config credentials take precedence when present. */
    apiKey: z.string().optional(),
    jobsApiUrl: z.string().url(),
  }),

  agent: z.object({
    displayName: z.string(),
    identityId: z.string().uuid(),
    metadata: z.record(z.string(), z.unknown()).optional(),
  }),

  pools: z.array(poolSchema).min(1, 'At least one pool is required'),

  polling: z
    .object({
      intervalMs: z.number().int().positive().default(DEFAULTS.polling.intervalMs),
      batchSize: z.number().int().positive().default(DEFAULTS.polling.batchSize),
    })
    .default(DEFAULTS.polling),

  concurrency: z
    .object({
      maxJobs: z.number().int().positive().default(DEFAULTS.concurrency.maxJobs),
    })
    .default(DEFAULTS.concurrency),

  executors: z.record(z.string(), executorSchema),

  logging: z
    .object({
      level: z
        .enum(['debug', 'info', 'warn', 'error'])
        .default(DEFAULTS.logging.level),
      format: z.enum(['pretty', 'json']).default(DEFAULTS.logging.format),
    })
    .default(DEFAULTS.logging),
});

export { shuttleConfigSchema };
export type ShuttleConfig = z.infer<typeof shuttleConfigSchema>;
